import { helper, http } from "../util";

const controller = "ruletext";

//types
export const RESET_STORE = "RESET_STORE";
export const REQUEST_RULETEXT = "REQUEST_RULETEXT";
export const RECIEVE_RULETEXT = "RECIEVE_RULETEXT";

//methods
const _resetStore = () => ({ type: RESET_STORE });
export const resetStore = () => (dispatch) => dispatch(_resetStore());

const requestItem = () => ({ type: REQUEST_RULETEXT });
const recieveItem = (payload) => ({ type: RECIEVE_RULETEXT, payload });
export const getAll = (id) => (dispatch) => {
    dispatch(requestItem());

    return dispatch(() =>
        http
            .get(helper.getApiPath(controller, "GetAll"), id)
            .then((data) => dispatch(recieveItem(data)))
    );
};
